<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="1300"
    scrollable
    :fullscreen="fullscreen"
  >
    <the-card
      :id="id"
      :application="application"
      @close-dialog="close"
    ></the-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { ACTIONS, GETTERS, MUTATIONS } from "@/store";

import TheCard from "@/components/TheCard";

export default {
  name: "TheCardDialog",
  components: { TheCard },
  data: () => ({}),
  props: {
    id: { type: Number, required: true },
    dialog: { type: Boolean, required: true },
    application: { type: String },
  },
  computed: {
    ...mapGetters({ dict4: GETTERS.DICTIONARY_4 }),
    fullscreen() {
      return false;
    },
  },
  methods: {
    ...mapActions({
      loadDictionary: ACTIONS.LOAD_DICTIONARY,
      loadCard: ACTIONS.LOAD_CARD_DATA,
    }),
    ...mapMutations({
      clearData: MUTATIONS.CLEAR_CARD_DATA,
    }),
    close() {
      this.$emit("input", false);
    },
    load(value) {
      if (value) {
        if (this.dict4.length === 0) {
          this.loadDictionary();
        }
        if (this.id === undefined || this.id === -1) {
          this.clearData();
        } else {
          this.clearData();
          this.loadCard(this.id);
        }
      }
    },
  },
  watch: {
    dialog: "load",
  },
};
</script>
